export { default as PaymentTab } from "./Payment";
export { default as PasswordTab } from "./Password";
export { default as ProfileTab } from "./Profile";
export { default as SettingsTab } from "./Settings";
